
import React from 'react';
import { Bar, Pie } from 'react-chartjs-2';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import ErrorBoundary from '../Containers/ErrorBoundary/ErrorBoundary';
import { classNames } from '../../Services/helpers';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
);

const BarChart = ({data, options, size = 'h-full'}) => {
    return <ErrorBoundary>
        <div className={classNames('relative ', size)}>
            <Bar data={data} options={options} />
        </div>
    </ErrorBoundary>
}

const PieChart = ({data, options, size = 'h-full'}) => {
    return <ErrorBoundary>
        <div className={classNames('relative ', size)}>
            <Pie data={data} options={options} />
        </div>
    </ErrorBoundary>
}

export {
    BarChart,
    PieChart,
}
